import {
  FormControl as ChakraFormControl,
  FormControlOptions,
  FormLabel,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
} from '@chakra-ui/react'
import styled from '@emotion/styled'

export const StyledFormNumberInputControl = styled(ChakraFormControl)`
  .chakra-form__label {
    opacity: ${(p) => (p.labelOpacity ? p.labelOpacity : 0.5)};
    color: ${(p) => (p.labelColour ? p.labelColour : '#2d2e41')};
    font-size: 16px;
    letter-spacing: -0.8px;
  }
`
const DEFAULT_MAX_INPUT = 365

export interface FormNumberInputControlIProps extends FormControlOptions {
  label?: string
  labelColour?: string
  labelOpacity?: number
  id?: string
  width?: string
  isDisabled?: boolean
  value?: number
  min?: number
  max?: number
  size?: 'sm' | 'md' | 'lg' | 'xs'
  defaultValue?: number
  onChange: (valueAsString: string, valueAsNumber: number) => void
}

export const FormNumberInputControl = ({
  id,
  isDisabled,
  label,
  labelColour,
  labelOpacity,
  width = '100%',
  value,
  onChange,
  min = 0,
  max = DEFAULT_MAX_INPUT,
  size = 'lg',
  defaultValue = 0,
}: FormNumberInputControlIProps) => {
  const handleChange = (valueAsString: string, valueAsNumber: number) => {
    const sanitizedValue = Number.isNaN(valueAsNumber) ? min : valueAsNumber
    onChange(valueAsString || String(sanitizedValue), sanitizedValue)
  }

  return (
    <StyledFormNumberInputControl
      id={id}
      labelColour={labelColour}
      labelOpacity={labelOpacity}
      width={width}
    >
      <FormLabel htmlFor={id} mr='0'>
        {label}
      </FormLabel>
      <NumberInput
        clampValueOnBlur
        defaultValue={defaultValue}
        max={max}
        min={min}
        onChange={handleChange}
        size={size}
        value={value}
      >
        <NumberInputField
          bgColor='white'
          borderColor='#9FB8E5'
          borderWidth='2px'
          fontSize='14px'
          fontWeight={600}
          textColor={isDisabled ? 'rgba(0,0,0,0.5)' : '#000'}
          variant='outline'
        />
        <NumberInputStepper>
          <NumberIncrementStepper color='#CCCCCC' />
          <NumberDecrementStepper color='#CCCCCC' />
        </NumberInputStepper>
      </NumberInput>
    </StyledFormNumberInputControl>
  )
}
